var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"repeat-option-warning"},[_c('strong',[_vm._v("\n\t\t"+_vm._s(_vm.$t('calendar', 'This event is the recurrence-exception of a recurrence-set. You cannot add a recurrence-rule to it.'))+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }